"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphicOptionIsAvailable = exports.getGraphicForOutputType = exports.getGraphic = void 0;
function getGraphic(design, id, { require = false, outputType } = {}) {
    const graphic = design.features[id];
    if ((graphic === null || graphic === void 0 ? void 0 : graphic.type) === "GRAPHIC") {
        if (outputType) {
            return getGraphicForOutputType(graphic, outputType);
        }
        else {
            return graphic;
        }
    }
    else {
        if (require) {
            throw new Error(`No graphic found with the id ${id}`);
        }
        else {
            return undefined;
        }
    }
}
exports.getGraphic = getGraphic;
/**
 * Filters a graphics options by what is available given the current output type.
 */
function getGraphicForOutputType(graphic, outputType) {
    return Object.assign(Object.assign({}, graphic), { options: graphic.options.filter(option => graphicOptionIsAvailable(option, outputType)) });
}
exports.getGraphicForOutputType = getGraphicForOutputType;
/**
 * Determines whether a graphic option should be available given an output type.
 */
function graphicOptionIsAvailable(option, outputType) {
    return !option.outputTypes || option.outputTypes.includes(outputType);
}
exports.graphicOptionIsAvailable = graphicOptionIsAvailable;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR3JhcGhpY1V0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL0dyYXBoaWNVdGlscy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBWUEsU0FBZ0IsVUFBVSxDQUN4QixNQUF3QyxFQUN4QyxFQUFVLEVBQ1YsRUFBRSxPQUFPLEdBQUcsS0FBSyxFQUFFLFVBQVUsS0FBd0IsRUFBRTtJQUV2RCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3BDLElBQUksQ0FBQSxPQUFPLGFBQVAsT0FBTyx1QkFBUCxPQUFPLENBQUUsSUFBSSxNQUFLLFNBQVMsRUFBRTtRQUMvQixJQUFJLFVBQVUsRUFBRTtZQUNkLE9BQU8sdUJBQXVCLENBQUMsT0FBTyxFQUFFLFVBQVUsQ0FBQyxDQUFDO1NBQ3JEO2FBQU07WUFDTCxPQUFPLE9BQU8sQ0FBQztTQUNoQjtLQUNGO1NBQU07UUFDTCxJQUFJLE9BQU8sRUFBRTtZQUNYLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0NBQWdDLEVBQUUsRUFBRSxDQUFDLENBQUM7U0FDdkQ7YUFBTTtZQUNMLE9BQU8sU0FBUyxDQUFDO1NBQ2xCO0tBQ0Y7QUFDSCxDQUFDO0FBbkJELGdDQW1CQztBQUVEOztHQUVHO0FBQ0gsU0FBZ0IsdUJBQXVCLENBQ3JDLE9BQXVCLEVBQ3ZCLFVBQTZCO0lBRTdCLHVDQUNLLE9BQU8sS0FDVixPQUFPLEVBQUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FDdkMsd0JBQXdCLENBQUMsTUFBTSxFQUFFLFVBQVUsQ0FBQyxDQUM3QyxJQUNEO0FBQ0osQ0FBQztBQVZELDBEQVVDO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQix3QkFBd0IsQ0FDdEMsTUFBcUIsRUFDckIsVUFBNkI7SUFFN0IsT0FBTyxDQUFDLE1BQU0sQ0FBQyxXQUFXLElBQUksTUFBTSxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLENBQUM7QUFDeEUsQ0FBQztBQUxELDREQUtDIn0=